<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <div class="d-flex align-center justify-space-between textColor rounded-lg px-4 py-2">
        <p class="sm-font300-14 primary--text mb-0">مشاهده دوره</p>
        <v-icon>mdi-chevron-left</v-icon>
      </div>
      <div class="textColor px-6 py-8 rounded-lg mt-3 d-flex flex-column">
        <v-row>
          <v-col md="5" cols="12">
            <v-card class="rounded-xl pt-5 px-4 pb-8" elevation="3">
              <div class="d-flex flex-column justify-center">
                <!-- <img src="@/assets/images/Shared/defaultImg.svg"/> -->
                <img :src="baseCourseData.image" />
                <!--                <p class="text-center sm-font600-16 mt-3 mb-1">{{ baseCourseData.course_type }}</p>-->
                <p class="text-center sm-font600-16 mt-3 mb-1">تکمیلی</p>
                <p :class="[baseCourseData.is_active ? 'active-Step' : 'inactive-Step']"
                  class=" text-center sm-font500-12">
                  {{ baseCourseData.is_active ? 'فعال' : 'غیرفعال' }}</p>
              </div>
              <p class="sm-font600-16 thirdColor--text mb-1">اطلاعات دوره</p>
              <v-divider class="mb-3" />
              <p class="sm-font500-12 gray--text">
                نام دوره: {{ baseCourseData.title }}
              </p>
              <p class="sm-font500-12 gray--text">
                تعداد برنامه ها: {{ baseCourseData.lesson_count }}
              </p>
              <p class="sm-font500-12 gray--text">
                تعداد حرکات: {{ baseCourseData.session_count }}
              </p>
              <p class="sm-font600-16 thirdColor--text mb-1 mt-10">توضیحات</p>
              <v-divider class="mb-3" />
              <p class="sm-font400-14 gray--text" style="line-height: 28px">
                {{ baseCourseData.description }}
              </p>
            </v-card>
          </v-col>
          <v-col md="6" cols="12">
            <p class="sm-font600-16 thirdColor--text mb-1 mt-4">برنامه ها و حرکات</p>
            <v-divider class="mb-3" />
            <v-row>
              <v-col md="6" cols="12" v-for="(item, index) in allPlans" :key="index">
                <v-btn block class="thirdColor--text sm-font500-16 rounded-xl me-3" outlined
                  style="border-color: #8D9DC7" depressed height="48" @click="openDetailModal(item)">
                  <div class="d-flex align-center justify-space-between w-100">
                    <p class="mb-0">{{ item.title }}</p>
                    <v-icon size="20">mdi-eye</v-icon>
                  </div>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-btn color="positive" to="/courses/course-list"
          class="textColor--text sm-font500-16 rounded-xl me-3 align-self-end" depressed height="48" width="230"
          style="margin-top: 124px">
          بازگشت
        </v-btn>
      </div>
    </v-card>
    <v-dialog v-model="actionModal" width="520">
      <v-card class="rounded-xl py-8 px-6" elevation="0">
        <div class="d-flex align-center mb-10">
          <!--          <v-icon class="mx-2">mdi-arrow-right</v-icon>-->
          <p class="mb-0 sm-font600-16 textColorSecond--text">برنامه ها و حرکات</p>
        </div>
        <v-tabs v-model="tab" fixed-tabs class="mb-4">
          <v-tabs-slider color="thirdColor"></v-tabs-slider>

          <v-tab href="#online" @change="getOnlineSessions">
            آنلاین
          </v-tab>

          <v-tab href="#offline" @change="getOfflineSessions">
            آفلاین
          </v-tab>

        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item value="online">
            <div v-for="(item, index) in allActions" :key="index">
              <v-row align="end">
                <v-col md="4" cols="12" class="text-center sm-font400-14">{{ item.title }}</v-col>
                <v-col md="4" cols="12" class="text-end sm-font400-12">{{ item.description }}</v-col>
                <v-col md="4" cols="12" class="text-end">
                  <v-icon color="thirdColor">mdi-play-circle-outline</v-icon>
                </v-col>
              </v-row>
              <v-divider class="my-4" />
            </div>
          </v-tab-item>


          <v-tab-item value="offline">
            <div v-for="(item, index) in allActions" :key="index">
              <v-row align="end">
                <v-col md="4" cols="12" class="text-center sm-font400-14">{{ item.title }}</v-col>
                <v-col md="4" cols="12" class="text-end sm-font400-12">{{ item.description }}</v-col>
                <v-col md="4" cols="12" class="text-end">
                  <v-icon color="thirdColor">mdi-play-circle-outline</v-icon>
                </v-col>
              </v-row>
              <v-divider class="my-4" />
            </div>
          </v-tab-item>
        </v-tabs-items>
        <v-btn @click="actionModal = false" color="positive" class="textColor--text sm-font500-16 rounded-xl me-3 mt-8"
          depressed height="48" block>
          بازگشت
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import courseApi from '@/Services/modules/courses'

export default {
  name: "viewAdditional",
  data() {
    return {
      actionModal: false,
      baseCourseData: {},
      allPlans: [],
      allActions: [],
      tab: null,
      lessonId: null
    }
  },
  mounted() {
    this.getBaseCourseData()
    this.getPlansData()
  },
  methods: {
    getBaseCourseData() {
      courseApi.getBaseCourseById(this.$route.params.id).then(res => {
        this.baseCourseData = res.data
      })
    },
    getPlansData() {
      let data = {
        course: this.$route.params.id
      }
      courseApi.getLessons(data).then(res => {
        this.allPlans = res.data.results
      })
    },
    openDetailModal(item) {
      this.lessonId = item.id
      courseApi.getSessions({ lesson: item.id, session_type: "Online"  }).then((res) => {
        this.actionModal = true
        this.allActions = res.data.results
      })
    },
    getOnlineSessions() {
      courseApi.getSessions({ lesson: this.lessonId, session_type: "Online" }).then((res) => {
        this.allActions = res.data.results
      })
    },
    getOfflineSessions() {
      courseApi.getSessions({ lesson: this.lessonId, session_type: "Offline" }).then((res) => {
        this.allActions = res.data.results
      })
    }
  }
}
</script>

<style scoped>
.active-Step {
  background-color: #EAFFDC;
  color: #45C98A;
  border-radius: 20px;
  width: 95px;
  padding: 4px 0;
}
</style>